import type { OfferedService, PackagedService } from "../../types/listingModels";
import type { ExpertListingPackagedServiceRequest } from "@shopexperts/shared";
import { PRICE_TYPE } from "@shopexperts/shared";

/**
 * Transforms offered services form data to API-ready format
 * Pure function - no side effects, no async operations
 * Only extracts IDs from the UI-enriched category objects
 */
export function transformOfferedServicesToApi(services: OfferedService[]) {
    return services.map(service => ({
        id: service.id || undefined,
        service_category_id: service.service_category.id,
        service_subcategory_ids: service.sub_categories.map(s => s.id),
    }));
}

/**
 * Transforms packaged services to API format
 * Pure function - just handles nullable ID conversion
 */
export function transformPackagedServicesToApi(
    services: PackagedService[]
): ExpertListingPackagedServiceRequest[] {
    return services.map((p) => ({
        id: p.id != null ? Number(p.id) : undefined,
        service_name: p.service_name,
        featured_media_id: p.thumbnail?.media_id || null,
        gallery_media_ids: p.gallery_images?.map(img => img.media_id).filter((id): id is string => !!id) || null,
        starting_price: p.starting_price,
        price_type: p.price_type ?? PRICE_TYPE.FIXED,
        description: p.description || null,
    }));
}

